import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { SafetyObservationsComponent } from './safety-observations/safety-observations.component';

const routes: Routes = [
  {
    path: 'safety-observations',
    component: SafetyObservationsComponent,
    canActivate: [
      AuthGuard
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SafetyObservationsRoutingModule { }
